import { PropsWithChildren } from 'react'

import { useLexicalEditable } from '@lexical/react/useLexicalEditable'

import { LinkForm } from './Form'
import { LinkCardStoreProvider } from './Store'
import { LinkToolbar } from './Toolbar'

export const LinkCard = ({ children }: PropsWithChildren) => {
  const editable = useLexicalEditable()

  if (!editable) {
    return null
  }

  return (
    <LinkCardStoreProvider>
      <LinkForm />
      <LinkToolbar />
      {children}
    </LinkCardStoreProvider>
  )
}
